import React from 'react';
import { Button, Icon, Table, Header, Popup, Form, Input, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import SearchTableData from '../../util/SearchTableData';
import { Link } from 'react-router-dom';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema arhiviranih predmeta.</p>;
const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema arhiviranih predmeta-</p>;

export default class ArchivedCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            faculties: [],

            loading: true,
            results: []

        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getCourses = this.getCourses.bind(this);
    }

    componentDidMount() {
        this.getCourses();
    }

    getCourses() {
        this.setState({ loading: true });
        axios.get(`course/basic/${this.props.orgUnitId}/true`)
            .then(res => {
                this.setState({ data: res.data, loading: false });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
    }


    render() {
        return (
            <div>
                {this.state.loading ?
                    <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                    this.getDataToRender().length ?
                        <Table celled selectable compact >
                            <Table.Header >
                                <Table.Row>
                                    <Table.HeaderCell colSpan={6} >
                                        <div style={{ paddingLeft: '30px' }}>
                                            <SearchTableData data={this.state.data} getResults={this.getResults} filterItem={['name', 'englishName']} />
                                        </div>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        <Header as="h4">
                                            <Header.Content>
                                                Naziv predmeta
                                            </Header.Content>
                                            <Header.Subheader>B/H/S jezik</Header.Subheader>
                                        </Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <Header as="h4">
                                            <Header.Content>
                                                Naziv predmeta
                                            </Header.Content>
                                            <Header.Subheader>Engleski jezik</Header.Subheader>
                                        </Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width="2">
                                        Napomena
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width="1">
                                        Globalni predmet
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width="1">
                                        Finalni predmet
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Matični fakultet
                                    </Table.HeaderCell>
                                    <Table.HeaderCell />
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {this.getDataToRender().map((el, index) =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell verticalAlign="middle" >
                                        {el.name}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" >
                                        {el.englishName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" >
                                        {el.comment}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" width="2">
                                        {el.global ? 'DA' : 'NE'}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" width="2">
                                        {el.finalCourse ? 'DA' : 'NE'}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.mainFaculty ? el.mainFaculty.name ? el.mainFaculty.name : '' : ''}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" textAlign="center">

                                        <Link to={{ pathname: '/predmeti/detalji-i-aktiviranje', state: { name: el.name, id: el.id } }}>
                                            <Popup
                                                content="Aktiviranje predmeta"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        color="blue"
                                                        size="small"
                                                        circular
                                                        icon="sign-in"
                                                    >
                                                    </Button>}
                                            >
                                            </Popup>
                                        </Link>
                                    </Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                        : this.state.filterMode ?
                            <div><br /><NoFilterDataMessage /></div>
                            : <div><br /><NoDataMessage /></div>
                }

                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/ArchivedCourses.js